import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'pv-shared-tracking-progress-bar',
    templateUrl: './shared-tracking-progress-bar.component.html',
    styleUrls: ['./shared-tracking-progress-bar.component.scss'],
    standalone: false
})
export class SharedTrackingProgressBarComponent implements OnInit {
  @Input() trackingStatus: string;
  @Input() firstBarProgress = 0;
  @Input() secondBarProgress = 0;

  constructor() { }

  ngOnInit(): void {
  }

}
